// Global Privacy Control (https://globalprivacycontrol.org): browsers with
// the signal enabled expose navigator.globalPrivacyControl === true and send
// a `Sec-GPC: 1` header. CCPA/CPRA requires treating the signal as an opt-out
// of the "sale or sharing" of personal info even when the visitor never
// interacts with a consent UI, so marketing/tracking scripts must not load
// for these visitors (LADD-3924).

export const gpcOptedOut = (): boolean =>
  typeof navigator !== "undefined" &&
  (navigator as Navigator & { globalPrivacyControl?: boolean })
    .globalPrivacyControl === true;

// Wraps an inline-script body so it no-ops for GPC visitors. Guarding at
// execution time (rather than conditionally rendering the <script> tag)
// keeps server-rendered HTML identical for every visitor — no hydration
// mismatch and no flash of divergent markup.
export const withGpcGuard = (js: string): string =>
  `if(!(typeof navigator!=="undefined"&&navigator.globalPrivacyControl===true)){${js}}`;
